export default "__VITE_ASSET__9fksVX9O__"